// extracted by mini-css-extract-plugin
module.exports = {"statBlock":"visual_statBlock__2tp5-","long":"visual_long__cNky0","header2":"visual_header2__4exmK"};